<template>
    <span>
        {{ num }}
    </span>
</template>
<script>
export default {
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object // 当前field对象
  },
  computed: {
  },
  data () {
    return {
      num: ''
    }
  },
  // 监听this.record
  watch: {
  },

  mounted () {
    console.log(this.record)
    this.init()
  },
  methods: {
    async init () {
      if (this.record.level === '0' || this.record.level === '1' || this.record.level === '2') {
        this.num = '-'
        return
      }
      let match = { isDelete: false }

      if (this.record.level === '3') {
        match.agency = this.record.department.objectId
        match.agent = this.record.objectId
      }
      if (this.record.level === '4') {
        match.salesmancy = this.record.department.objectId
        match.salesman = this.record.objectId
      }
      let res = await this.$tkParse.get('/aggregate/store', {
        params: {
          group: {
            objectId: '', // 用来分组的字段，留空代表不分组
            total: { // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: match
        }
      })
      if (res.data.results.length) {
        this.num = res.data.results[0].total || 0
      } else {
        this.num = 0
      }
    }

  }
}
</script>
